import { render, staticRenderFns } from "./publicbenact.vue?vue&type=template&id=a8035d86&scoped=true&"
import script from "./publicbenact.vue?vue&type=script&lang=js&"
export * from "./publicbenact.vue?vue&type=script&lang=js&"
import style0 from "./publicbenact.vue?vue&type=style&index=0&id=a8035d86&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8035d86",
  null
  
)

export default component.exports